import * as React from "react";
import { ChipField } from "../../../../Components/Form/ChipField";

interface ITransactionFilterProps {
    value: string[];
    onChange(excludedTransactions: string[]): void;
}

export const ExcludeTransactionsFilter = ({value, onChange}: ITransactionFilterProps) => {
    return (
        <ChipField
            value={value}
            onChange={onChange}
            label="Exclude transactions (ID)"
        />
    );
}
